import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { PRICE, TOTAL_VALUE } from './Pricing';
export function Close() {
  return <section className="w-full border-y-4 border-amber bg-rink" data-id="element-74" data-mp="1zvl8uujupydw">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-75" data-mp="1uwrrus5cvp8z">
        <h2 className="font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-76" data-mp="1q01guj8erjuf">
          Keep your evenings.{' '}
          <span className="text-amber" data-id="element-77" data-mp="1l0yifhmxobvf">Open the week and coach.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-78" data-mp="1g96ttcnc8g7x">
          Glides, edges, turns, jumps and spins, the season show and the season
          close. Fifty-two lessons — three lanes each, ready to run.
        </p>

        <div className="mt-7" data-id="element-79" data-mp="17albnils337o">
          <Countdown size="sm" tone="dark" data-id="element-80" data-mp="129ntv74okb6p" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-card border border-amber bg-amber/10 px-5 py-4 text-left" data-id="element-81" data-mp="1295rrtvc72qv">
          <div data-id="element-82" data-mp="3vevjnyv155sn">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-amber" data-id="element-83" data-mp="3vedlgwot4hi3">
              Complete package
            </span>
            <span className="text-[15px] font-semibold text-white" data-id="element-84" data-mp="42k8atqjzeb4">
              Figure Skating Class Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-85" data-mp="3qgtviziqygab">
            <span className="text-[15px] text-white/60 line-through" data-id="element-86" data-mp="hzz6onysawf8">${TOTAL_VALUE}</span>
            <span className="font-display text-4xl font-extrabold leading-none text-white" data-id="element-87" data-mp="mzbpmxmjbjcj">
              ${PRICE}
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-88" data-mp="822sfnajvlcw">
          <CtaButton data-id="element-89" data-mp="d0w7hk5hjkf6">Yes, I want the 3-Lane season — ${PRICE}</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-90" data-mp="2sstkaabty3py">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-91" data-mp="148o07ecbg2b0">
                <span className="h-1.5 w-1.5 rounded-full bg-amber" data-id="element-92" data-mp="14b0g7lyik2lf" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}